var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg121(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "134") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-night",
    transform: "translate(-837.000000, -6.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: 134,
    transform: "translate(837.398961, 13.396364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.48311688,0 C7.60342217,0 8.65735029,0.28414858 9.57676402,0.78430852 C7.75027743,2.32525347 6.52822983,4.55970479 6.31645091,7.08155844 L6.31645091,7.08155844 L5.78523429,7.08155844 C3.73949522,7.08155844 1.92626436,8.07432304 0.80064591,9.60423403 C0.289966462,8.67881302 0,7.61483307 0,6.48311688 C0,2.9025413 2.9025413,0 6.48311688,0 Z",
    id: "Combined-Shape",
    fill: "#BEE4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5465143,0.0997402597 C18.4072755,0.0997402597 20.9711487,1.66012198 22.3208755,4.06232774 C19.9580164,5.07104558 18.2538212,7.31658046 18.0291491,9.98120727 L18.0291491,9.98120727 L17.6207127,9.98120727 C14.9943522,9.98120727 12.8664935,12.1006878 12.8664935,14.715279 C12.8664935,15.9680941 13.3550176,17.1070477 14.1526853,17.9537024 L5.78523429,17.9532468 C3.19567792,17.9532468 1.09714286,15.8549112 1.09714286,13.2654545 C1.09714286,10.7481212 3.0806176,8.69462626 5.57060114,8.5824856 L5.78523429,8.57766234 L7.69216831,8.57766234 L7.80736831,7.20673247 C8.14349299,3.20395636 11.5028447,0.0997402597 15.5465143,0.0997402597 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1249704,4.98701299 C27.5295086,4.98701299 29.6433039,6.50087065 30.4305538,8.71769766 L30.4305538,8.71769766 L30.845573,9.88645403 L32.0710816,9.69525195 C32.2858223,9.66173922 32.504453,9.64478338 32.7258764,9.64478338 C35.0347636,9.64478338 36.9038961,11.5060364 36.9038961,13.7990649 C36.9038961,16.091894 35.0347636,17.9532468 32.7258764,17.9532468 L32.7258764,17.9532468 L17.6207127,17.9532468 C15.8197029,17.9532468 14.3625974,16.5025247 14.3625974,14.715279 C14.3625974,12.928133 15.8194036,11.4773112 17.6207127,11.4773112 L17.6207127,11.4773112 L19.4042681,11.4773112 L19.5199668,10.10688 C19.762934,7.22488519 22.1949008,4.98701299 25.1249704,4.98701299 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3444183,28.3276301 C21.3444183,29.8692156 20.0940717,31.118961 18.5516883,31.118961 C17.0093049,31.118961 15.758961,29.8692156 15.758961,28.3276301 C15.758961,27.9005423 15.8549112,27.4957964 16.0265642,27.133839 L17.5904914,23.154801 C18.1209101,21.8053153 18.9804717,21.8043179 19.5111896,23.154801 L21.0678358,27.1150878 C21.2504461,27.4931846 21.3450069,27.9077452 21.3444183,28.3276301 L21.3444183,28.3276301 Z",
    id: "Path",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg121);
export default __webpack_public_path__ + "static/media/121.12c5fa547857867cdf97b0590320dddc.svg";
export { ForwardRef as ReactComponent };